<template>
  <div class="bb-container">
    <div class="top">
      <div class="block">
        <div class="block-item">
          <img :src="'data:image/png;base64,'+item.user.headimgBase64">
          <div class="block-label">
            <span :style="item.user.sex==0?'color: #ff9db3;':'color: #1296db'">
              {{item.user.nickname}}
              <i class="iconfont icon-nan2" v-if="item.user.sex==1"></i>
              <i class="iconfont icon-nv2" v-else></i>
            </span>
          </div>
        </div>
      </div>
      <div class="vs">
        <img src="/static/bb-xian.png" style="width: 72px;">
      </div>
      <div class="block">
        <div class="block-item">
          <img :src="item.header">
          <div class="block-label">
            <span :style="item.sex==0?'color: #ff9db3;':'color: #1296db'">
              {{item.nickname}}
              <i class="iconfont icon-nan2" v-if="item.sex==1"></i>
              <i class="iconfont icon-nv2" v-else></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="word">
      <span v-html="item.word"></span>
      <img class="talk" src="/static/talk.png" :style="'left: '+talkLeft+'px;'">
    </div>
    <div class="pics-container">
      <div class="pics" v-if="item.pics && item.pics.length > 0">
        <img
          class="mai-pic"
          v-for="(pic, index) in item.pics"
          :key="'pic_'+index"
          :src="pic"
          :style="imgStyle(index)"
          @click="showImagePreview(index)"
        >
      </div>
    </div>
    <div class="item-footer">
      <div class="viewzan">
        <div class="item-footer-item" @click="zan">
          <i class="iconfont icon-dianzan"></i>
          <span>{{item.zan}}人</span>
        </div>
        <div class="item-footer-item" @click="cai">
          <i class="iconfont icon-diancai"></i>
          <span>{{item.cai}}人</span>
        </div>
        <div class="item-footer-item" @click="flower">
          <i class="iconfont icon-biaoqian-pingjia"></i>
          <span>{{item.flower}}花</span>
        </div>
      </div>
      <div class="handle-bnt">
        <span>{{createTime}}前发布</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import weui from "weui.js";

export default {
  props: {
    item: Object,
    openid: String
  },
  data() {
    return {
      leftBorderStyle: "",
      rightBorderStyle: "",
      createTime: null,
      picWidth: 0,
      talkLeft: 0,
      initialIndex: 0
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    let du = moment.duration(moment() - moment(this.item.createdAt), "ms");
    this.createTime = du.locale("zh-cn").humanize();

    if (this.item.word) {
      this.item.word = this.item.word.replace(/\n/g, "<br/>");
    }

    if (this.item.sex == 0) {
      this.borderStyle =
        "border: 1px solid #ff9db3; border-radius: 10px; margin: 10px;";
    } else if (this.item.sex == 1) {
      this.borderStyle =
        "border: 1px solid #1296db; border-radius: 10px; margin: 10px;";
    }
  },
  methods: {
    imgStyle(index) {
      if (index == 2 || index == 5 || index == 8) {
        let style =
          "width:" +
          this.picWidth +
          "px; height:" +
          this.picWidth +
          "px; margin-right: 0px;";
        return style;
      } else {
        let style =
          "width:" + this.picWidth + "px; height:" + this.picWidth + "px;";
        return style;
      }
    },
    showImagePreview(index) {
      this.initialIndex = index;
      const params = {
        $props: {
          imgs: this.item.pics,
          initialIndex: "initialIndex", // 响应式数据的key名
          loop: false
        },
        $events: {
          change: i => {
            // 必须更新 initialIndex
            this.initialIndex = i;
          }
        }
      };
      this.$createImagePreview({ ...params }).show();
    },
    zan() {
      axios
        .put("/api/circle/active/" + this.item._id, {
          bizType: 30,
          type: 20,
          openid: this.openid
        })
        .then(res => {
          if (res.data.data == 0) {
            weui.toast("您已赞过", 500);
          } else {
            this.item.zan++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    cai() {
      axios
        .put("/api/circle/active/" + this.item._id, {
          bizType: 30,
          type: 30,
          openid: this.openid
        })
        .then(res => {
          if (res.data.data == 0) {
            weui.toast("您已踩过", 500);
          } else {
            this.item.cai++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    flower() {
      axios
        .put("/api/circle/active/" + this.item._id, {
          bizType: 30,
          type: 50,
          openid: this.openid
        })
        .then(res => {
          if (res.data.data == 0) {
            weui.toast("您已送过花", 500);
          } else {
            this.item.flower++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.picWidth = parseInt((document.body.clientWidth - 72) / 3);
    this.talkLeft =
      parseInt(((document.body.clientWidth - 94) / 4)) - 30;
  }
};
</script>

<style scoped>
.bb-container {
  margin: 10px;
  border: 1px solid #ff9db3;
  border-radius: 10px;
}
.top {
  display: flex;
  width: 100%;
  margin-top: 10px;
}
.block {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.block-item {
  position: relative;
  text-align: center;
}
.block img {
  width: 65px;
  height: 65px;
  border-radius: 50%;
}
.block-label {
  text-align: center;
  margin-top: 5px;
}
.vs {
  display: flex;
  justify-content: center;
  align-items: center;
}
.vs i {
  font-size: 40px;
  font-weight: bold;
  color: #ff9db3;
}
.word {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 10px;
  border: 2px dashed #ff9db3;
  padding: 15px;
  padding-bottom: 10px;
  border-radius: 10px;
  position: relative;
  font-size: 15px;
}
.talk {
  width: 20px;
  position: absolute;
  top: -11px;
}
.icon-nan2 {
  color: #1296db;
}
.icon-nv2 {
  color: #ff9db3;
}
.pics-container {
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 1px solid #efefef;
}
.pics {
  padding-bottom: 5px;
}
.pic-bottom {
  padding-bottom: 10px;
}
.mai-pic {
  object-fit: cover;
  display: inline-block;
  margin-top: 5px;
  margin-right: 5px;
}
.item-footer {
  display: flex;
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 20px;
  padding-bottom: 10px;
}
.viewzan {
  flex: 1;
  display: flex;
  align-items: center;
}
.item-footer-item span {
  font-size: 15px;
  margin-left: 2px;
}
.item-footer-item + .item-footer-item {
  margin-left: 5px;
}
.handle-bnt {
  float: right;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}
</style>





// WEBPACK FOOTER //
// src/components/common/BiaobaiItem.vue